import { render, staticRenderFns } from "./club-list-page.vue?vue&type=template&id=a8b446a6&"
import script from "./club-list-page.vue?vue&type=script&lang=js&"
export * from "./club-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports